module.exports = __webpack_public_path__ + "static/img/case2.89964b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case2.png
// module id = 30
// module chunks = 0